// import Mock from "mockjs";
export default {
  getData: config => {
    const data = {};
    data.data = {
      baseInfo: {
        tenderResult: "中标", // 招标结果
        project: "上海", // 项目
        contractNumber: "19180931075", // 合同编号
        contractName: "北京", // 合同名称
        procurementMethod: "合同支付", // 采购方式
        owner: "生舒", // 甲方
        secondParty: "庹枫德", // 乙方
        signatory: "蒙静利", // 项目合同签订人
        signing: "1977-11-14", // 签订日期
        taxRate: "80%", // 税率
        reinforced: "64364554", // 采购计划总编号
        reference: "8673", // 招标编号
        compileDate: "1982-10-18", // 编制日期
        contract: "6641", // 合同总价（含税）
        contractAfterTax: "6280", // 合同总价（不含税）
        assessment: "2,000.00", // 税额
        combustible: "4883", // 变更后合同总价（含税）
        floating: "1", // 是否浮动合同价格
        customerName: "",
        combustibleNo: "4883", // 变更后合同总价（不含税）
        floatingTitle: "", // 浮动价说明
        mainTerms: "", // 合同主要条款
        responsibility: "01", // 价格填写方式
        postscript: "" // 备注
      },
      attachment: [
        {
          textName: "采购清单.xlsx", //合同附件里的文件名称
          txtlarge: "12KB" //合同附件里的文件大小
        },
        {
          textName: "生效上传.png", //合同附件里的文件名称
          txtlarge: "12KB" //合同附件里的文件大小
        }
      ],
      financeInfo: {
        priceRegion: "云南省", //价格地区
        taxMethod: "一般计税", //计税方法
        taxType: "普通发票", //发票类型
        placeSign: "陕西省", //签订地点
        numberCopies: "10", //合同份数
        phonePerson: "卢军", //对方联系人
        taxpayer: "一般纳税人", //供应商纳税人类型
        materialSources: "湖南省", //物资来源
        paymentCoefficient: "8", //支付系数
        advanceCharge: "4730", //预付款
        titleAccount: "四川渝帆建筑工程有限公司", //账户名称
        accountNumber: "51001890836051520502", //开户行账号
        accountName: "中国建设银行股份有限公司成都锦城支行" //开户行名称
      },
      inventoryList: [
        {
          suppliesNo: "EHJ-201907180101",
          suppliesName: "一标段名称",
          model: "吨",
          unit: "吨",
          num: "200",
          excludeTaxPrice: "200.00",
          excludeTaxAmount: "2,000.00",
          includeTax: "20.00",
          includeTaxPrice: "200.00",
          includeTaxAmount: "2,000.00",
          materialDesc: ""
        },
        {
          suppliesNo: "EHJ-201907180101",
          suppliesName: "一标段名称",
          model: "吨",
          unit: "吨",
          num: "200",
          excludeTaxPrice: "200.00",
          excludeTaxAmount: "2,000.00",
          includeTax: "20.00",
          includeTaxPrice: "200.00",
          includeTaxAmount: "2,000.00",
          materialDesc: ""
        },
        {
          suppliesNo: "EHJ-201907180101",
          suppliesName: "一标段名称",
          model: "吨",
          unit: "吨",
          num: "200",
          excludeTaxPrice: "200.00",
          excludeTaxAmount: "2,000.00",
          includeTax: "20.00",
          includeTaxPrice: "200.00",
          includeTaxAmount: "2,000.00",
          materialDesc: ""
        }
      ]
    };

    data.code = "0";
    data.msg = "成功";
    return data;
  }
};
